module.exports = __webpack_public_path__ + "img/user-placeholder.87321b02.png";